module.exports = __webpack_public_path__ + "platform/static/media/ipoLimit.3c569d1b.png";